import { register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './children-slot.css'

/**
 * Empty slot for children rendering component
 *
 * This is just a placeholder for children elements,
 * parent wrapper can use this placeholder to render anything inside it.
 * It needed because when player goes in fullscreen mode, it bubbles up, above all other elements,
 * and even max z-index won't help to render anything above it. So, to render something above player,
 * (for example, pin lock modal, or payment button, or anything else)
 * it should be rendered _inside_ player, and this component is exactly for that.
 */
@register
export class ChildrenSlot extends BaseComponent {}

ChildrenSlot.options = {
  className: 'vjs-x-children-slot',
}
